type UmamiValue = string | number | boolean | null | undefined
type UmamiData = Record<string, UmamiValue>
type QueuedUmamiCall =
  | { type: 'track', name: string, data?: Record<string, string | number | boolean | null> }
  | { type: 'identify', id: string, data?: Record<string, string | number | boolean | null> }

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, string | number | boolean | null>) => void
      identify: (idOrData: string | Record<string, string | number | boolean | null>, data?: Record<string, string | number | boolean | null>) => void
    }
    __descontitoUmamiQueue?: QueuedUmamiCall[]
  }
}

export function useUmami() {
  function normalizeData(data?: UmamiData) {
    if (!data) return undefined

    return Object.fromEntries(
      Object.entries(data).filter(([, value]) => value !== undefined),
    ) as Record<string, string | number | boolean | null>
  }

  function trackEvent(name: string, data?: UmamiData) {
    if (!import.meta.client) return

    const payload = { type: 'track' as const, name: name.slice(0, 50), data: normalizeData(data) }
    if (window.umami) {
      window.umami.track(payload.name, payload.data)
      return
    }

    window.__descontitoUmamiQueue = window.__descontitoUmamiQueue ?? []
    window.__descontitoUmamiQueue.push(payload)
  }

  function identifyUser(id: string, data?: UmamiData) {
    if (!import.meta.client) return

    const payload = { type: 'identify' as const, id, data: normalizeData(data) }
    if (window.umami) {
      window.umami.identify(payload.id, payload.data)
      return
    }

    window.__descontitoUmamiQueue = window.__descontitoUmamiQueue ?? []
    window.__descontitoUmamiQueue.push(payload)
  }

  return { trackEvent, identifyUser }
}
